<template>
  <div class="container_top">
    <div class="filter_back" @click="$router.go(-1)"></div>
    <div class="back_text">销量详情</div>
  </div>
  <div class="sales_container">
    <div class="filter_container">
      <div class="filter_top">
        <div class="filter_left">
          <div class="title">{{rank_name}}{{text_type[rank_type]}}销量数据</div>
          <div class="filter_time">
            <div class="filter_val">
                {{date_obj.name}}
            </div>
            <div class="filter_options_box">
                <div class="filter_options">
                    <div class="filter_option" :class="item.name == date_obj.name?'act':''" v-for="(item,ind) in date_list" :key="ind" @click="filterChangeFn(item,'date')">
                        {{item.name}}
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div class="filter_right">
          <span style="color:#D94B4B">*</span>数据源于车辆上牌信息，每月25号左右更新
        </div>
      </div>
      <!-- <div class="filter_bot">
        <div class="filter_time">
          <select class="province" v-model="province" @change="filterChange">
            <template v-for="(item, ind) in province_list" :key="ind">
              <option :value="item.val">
                {{ item.val }}
              </option>
            </template>
          </select>
        </div>
      </div> -->
    </div>
    <div class="content">
      <NodeName
        node_name="年销量数据"
      />
      <!-- <div class="bar_chart" v-show="xAxisData && xAxisData.length > 0"> -->
      <div class="bar_chart" v-loading="loading1">
        <BarChart
          :opts="{
            xAxisData: xAxisData,
            serieObj: serieObj,
            serieObj2: serieObj2,
          }"
        />
      </div>
      <!-- </div> -->
      <!-- <div v-show="xAxisDataProvince && xAxisDataProvince.length > 0"> -->
        <NodeName
          :node_name="date.slice(0, 4)+'年'+date.slice(4)+'月'+rank_name+'销量前十地区'"
        />
        <!-- <div class="section_tit">
          {{ date.slice(0, 4) }}年{{ date.slice(4) }}月{{
            province
          }}销量前十地区
        </div> -->
        <div class="bar_chart2" v-loading="loading2">
          <!-- <template v-if="xAxisDataProvince && serieObjProvince"> -->
            <BarChart
              :opts="{
                xAxisData: xAxisDataProvince,  
                serieObj: serieObjProvince,
              }"
            />
          <!-- </template> -->
        </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { salesAnalysis, salesTotal, getCityRank } from "@/api";
import BarChart from "@/components/sales/BarChart.vue";
import NodeName from "@/components/common/views/NodeName.vue";
export default {
  components: {
    BarChart,
    NodeName
  },
  data() {
    return {
      date: "",
      date_obj:{
        name:'',
        val:''
      },
      date_list: [],
      etype: 2,
      text_type:{
        'serie':'车系',
        'brand':'品牌',
        'province':'地区',
        'enterprise':'厂商'
      },
      rank_type: "",
      rank_name: "",
      rank_id:0,
      // province: "",
      // province_list: [
      //   {
      //     name: "全国",
      //     val: "全国"
      //   },
      //   {
      //     name: "北京",
      //     val: "北京"
      //   },
      //   {
      //     name: "天津",
      //     val: "天津"
      //   },
      //   {
      //     name: "上海",
      //     val: "上海"
      //   },
      //   {
      //     name: "重庆",
      //     val: "重庆"
      //   },
      //   {
      //     name: "河北",
      //     val: "河北"
      //   },
      //   {
      //     name: "山西",
      //     val: "山西"
      //   },
      //   {
      //     name: "辽宁",
      //     val: "辽宁"
      //   },
      //   {
      //     name: "吉林",
      //     val: "吉林"
      //   },
      //   {
      //     name: "黑龙江",
      //     val: "黑龙江"
      //   },
      //   {
      //     name: "江苏",
      //     val: "江苏"
      //   },
      //   {
      //     name: "浙江",
      //     val: "浙江"
      //   },
      //   {
      //     name: "安徽",
      //     val: "安徽"
      //   },
      //   {
      //     name: "福建",
      //     val: "福建"
      //   },
      //   {
      //     name: "江西",
      //     val: "江西"
      //   },
      //   {
      //     name: "山东",
      //     val: "山东"
      //   },
      //   {
      //     name: "河南",
      //     val: "河南"
      //   },
      //   {
      //     name: "湖北",
      //     val: "湖北"
      //   },
      //   {
      //     name: "湖南",
      //     val: "湖南"
      //   },
      //   {
      //     name: "广东",
      //     val: "广东"
      //   },
      //   {
      //     name: "海南",
      //     val: "海南"
      //   },
      //   {
      //     name: "四川",
      //     val: "四川"
      //   },
      //   {
      //     name: "贵州",
      //     val: "贵州"
      //   },
      //   {
      //     name: "云南",
      //     val: "云南"
      //   },
      //   {
      //     name: "陕西",
      //     val: "陕西"
      //   },
      //   {
      //     name: "甘肃",
      //     val: "甘肃"
      //   },
      //   {
      //     name: "青海",
      //     val: "青海"
      //   },
      //   {
      //     name: "台湾",
      //     val: "台湾"
      //   },
      //   {
      //     name: "广西",
      //     val: "广西"
      //   },
      //   {
      //     name: "内蒙古",
      //     val: "内蒙古"
      //   },
      //   {
      //     name: "西藏",
      //     val: "西藏"
      //   },
      //   {
      //     name: "宁夏",
      //     val: "宁夏"
      //   },
      //   {
      //     name: "新疆",
      //     val: "新疆"
      //   },
      //   {
      //     name: "香港",
      //     val: "香港"
      //   },
      //   {
      //     name: "澳门",
      //     val: "澳门"
      //   }
      // ],
      //柱状图 上 总销量和新能源（燃油）销量
      xAxisData: [],
      serieObj: {},
      serieObj2: {},
      //柱状图 下 销量前十地区
      xAxisDataProvince: [],
      serieObjProvince: {},

      loading1:false,
      loading2:false,
    };
  },
  created() {
    let { etype, date_obj, rank_id, rank_name, rank_type } = JSON.parse(
      this.$route.query.link_info
    );
    this.etype = etype;
    this.rank_name = rank_name;
    this.rank_type = rank_type;
    this.rank_id = rank_id;
    this.initDate(date_obj);

  },
  methods: {
    initDate(date_obj) {
      const that = this;
      salesAnalysis().then((res) => {
        // that.date = res.data.current_date;
        // that.date_obj = {
        //   name:res.data.current_date.slice(0,4)+'年'+res.data.current_date.slice(4)+'月',
        //   val:res.data.current_date
        // };
        let current_date = res.data.current_date;
        let last_date = res.data.last_date;
        let date_list = [];
        if (current_date.slice(0, 4) != last_date.slice(0, 4)) {
          let i = last_date.slice(4) * 1,
            j = 1;
          for (i; i <= 12; i++) {
            date_list.unshift({
              name:
                last_date.slice(0, 4) + "年" + (i < 10 ? "0" + i : i) + "月",
              val: last_date.slice(0, 4) + "" + (i < 10 ? "0" + i : i)
            });
          }
          for (j; j <= current_date.slice(4) * 1; j++) {
            date_list.unshift({
              name:
                current_date.slice(0, 4) + "年" + (j < 10 ? "0" + j : j) + "月",
              val: current_date.slice(0, 4) + "" + (j < 10 ? "0" + j : j)
            });
          }
        } else {
          let i = 1;
          for (i; i <= 12; i++) {
            date_list.unshift({
              name:
                last_date.slice(0, 4) + "年" + (i < 10 ? "0" + i : i) + "月",
              val: last_date.slice(0, 4) + "" + (i < 10 ? "0" + i : i)
            });
          }
        }
        that.date_list = JSON.parse(JSON.stringify(date_list));
        // that.date = date;
        that.date_obj = date_obj;

        that.getProvinceSales();
      });
    },
    //时间更改
    dateChange() {
      this.getProvinceSales();
    },
    // filterChange() {
    //   this.getProvinceSales();
    // },
    filterChangeFn(data,type){
      this[type+'_obj'] = data;
      this.getProvinceSales();
    },
    getProvinceSales() {
      const that = this;
      // 获取总销量
      let query_obj = {
        etype: that.etype,
        date: that.date_obj.val,
        rank_type: that.rank_type
      };
      query_obj.name = that.rank_type=='serie'?that.rank_id:that.rank_name;
      that.loading1 = true;
      that.loading2 = true;
      salesTotal(query_obj).then((res) => {
        if (res && res.code && res.code == 200) {
          let list = res.data;
          let xAxisData = [];
          let series_data = [];
          let series_data2 = [];
          list.reverse().forEach((item) => {
            xAxisData.push(item.date.slice(0, 4) + "/" + item.date.slice(4));
            series_data.push(item.total_smart_sales || 0);
            series_data2.push(item.total_sales || 0);
          });
          that.xAxisData = xAxisData;
          that.loading1 = false;
          that.serieObj = {
            name: (that.etype == 1 ? "燃油车" : "新能源车") + "销量",
            data: series_data
          };
          that.serieObj2 = {
            name: "总销量",
            data: series_data2
          };
        }
      });
      //获取前十地区
      getCityRank({
        rank_type: that.rank_type,
        etype: that.etype,
        name: that.rank_type == 'serie' ? that.rank_id :that.rank_name,
        date: that.date_obj.val
      }).then((res2) => {
        if (res2 && res2.code && res2.code == 200) {
          let list = res2.data;
          let xAxisData = [];
          let serieData = [];
          list.forEach((item) => {
            xAxisData.push(item.city);
            serieData.push(item.total_smart_sales);
          });
          that.loading2 = false;
          that.xAxisDataProvince = xAxisData;
          that.serieObjProvince = {
            name: "销量",
            data: serieData
          };
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container_top{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .filter_back{
    width: 40px;
    height: 30px;
    margin-right: 10px;
    cursor: pointer;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/back_20230221.svg) no-repeat center center;
    background-size: 18px;
  }
  .back_text{
    color: #777c89;
    font-size: 14px;
  }
}

.sales_container{
  width: 1224px;
  background: #FFFFFF;
  border-radius: 13px 0 0 0;
  padding: 53px 56px 53px 59px;
}
.filter_container {
  .filter_top{
    width: 100%;
    height: 145px;
    box-sizing: border-box;
    background:#F6F9FD url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/bg_20230213.png) no-repeat;
    background-size: auto 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 189px;
    padding-right: 46px;
    border-radius: 4px 4px 0px 0px;
    margin-bottom: 20px;
    .filter_left{
      .title{
        height: 20px;
        font-size: 20px;
        font-weight: bold;
        color: #000000;
        line-height: 20px;
      }
       
    }
    .filter_right{
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
    }
  }
  .filter_time{
    margin-top: 20px;
    height: 34px;
    width: 180px;
    margin-right: 18px;
    position: relative;
    cursor: pointer;
    .filter_val{
        width: 100%;
        height: 100%;
        line-height: 34px;
        font-size: 16px;
        text-align: center;
        color: #151515;
        padding-right:20px;
        background:#fff url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/sanjiao_20230223.png) no-repeat;
        background-size: 11px;
        background-position: calc(100% - 10px);
        border: solid 1px #E8E8E8;
    }
    .filter_options_box{
        display: none;
        position: absolute;
        top: 34px;
        left: 0;
        padding-top: 10px;
        z-index: 10;
        width: 100%;
    }
    .filter_options{
      width: 100%;
      max-height: 280px;
      overflow-y: auto;
      background: #fff;
      box-shadow: 0 0 3px 2px #ededed;
      .filter_option{
        width: 100%;
        padding:10px 20px;
        &.act{
            color: rgba(31, 188, 191, 1);
        }
        &:hover{
            background: rgba(31, 188, 191, .1);
            // color: rgba(31, 188, 191, .8);
        }
      }
    }
    &:hover .filter_options_box{
          display: block;
      }
      &:hover .filter_val{
          border: solid 1px #1FBCBF;
      }
  }
  // .filter_time {
  //   width: 180px;
  //   height: 44px;
  //   margin-right: 18px;
  //   select {
  //     width: 100%;
  //     height: 100%;
  //     appearance: none;
  //     border: none;
  //     outline: none;
  //     font-size: 16px;
  //     text-align: center;
  //     color: #151515;
  //     padding-right: 20px;
  //     border-radius: 4px;
  //     background: #fff
  //       url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/select.png) no-repeat;
  //     background-size: 11px;
  //     background-position: calc(100% - 10px);
  //     &::-ms-expand {
  //       display: none;
  //     }
  //   }
  // }
  // .filter_top {
  //   box-sizing: border-box;
  //   height: 137px;
  //   background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/home/filter_top2.png)
  //     no-repeat;
  //   background-size: 100%;
  //   padding-left: 20px;
  //   padding-top: 7px;
  //   .title {
  //     height: 46px;
  //     line-height: 46px;
  //     font-size: 32px;
  //     color: #fff;
  //   }
  // }
  // .filter_bot {
  //   height: 71px;
  //   display: flex;
  //   align-items: center;
  //   padding-left: 20px;
  // }
}
.content {
  .section_tit {
    height: 33px;
    line-height: 33px;
    margin: 50px 0;
    padding-left: 37px;
    color: #333333;
    font-size: 24px;
    font-weight: bold;
    position: relative;
    &::after {
      content: "";
      width: 11px;
      height: 33px;
      border-radius: 2px;
      background: #46b7e3;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .bar_chart,
  .bar_chart2 {
    width: 100%;
    height: 440px;
    margin-top: -50px;
    margin-bottom: 30px;
  }
}
</style>